import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setGroupIndex, getOrgUnitInfo } from '../../../../redux/actions'

// MUI
import {
  Grid, Paper, Stepper, Step, StepLabel, Button, Typography, TextField, Divider, Checkbox
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { TreeView } from '@material-ui/lab'
import { UnitTree } from '../../tools'
import { keyify2 } from '../../../../utils'

// The text for the stepper
const getSteps = () => {
  return ['Name and Description', 'Unit', 'Members', 'Review']
}

// const GreenRadio = withStyles({
//   root: {
//     color: '#A4D164',
//     '&$checked': {
//       color: '#8AB651'
//     }
//   },
//   checked: {}
// })((props) => <Radio color='default' {...props} />)

const GreenCheckbox = withStyles({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const SupGroupNew = (props) => {
  const {
    classes, handleBackTrack, stepperIcons, StepperConnector, TreeData, newGroupForm,
    setNewGroupForm, orgUnitInfo, handleSaveNewGroup
  } = props
  const steps = getSteps()
  const dispatch = useDispatch()

  // An item from the redux state object that keeps the stepper from resetting when the dispatch for the unit is called
  const GroupIndex = useSelector(state => state.selection.GroupIndex)

  const [groupNameInput, setNameInput] = useState('')
  const [groupDescInput, setDescInput] = useState('')

  const [noNameError, setNoName] = useState(false)
  const [noDescError, setNoDesc] = useState(false)
  const [noUnit, setNoUnit] = useState(false)
  const [noSups, setNoSups] = useState(false)

  const [expandedKeys, setExpandedKeys] = useState(keyify2(TreeData))
  const [unitSupervisors, setUnitSupervisors] = useState([])

  // Maps the supervisors retrieved from the dispatch and matches it with the first and last name in the supervisor list
  useMemo(() => {
    if (
      typeof orgUnitInfo === 'object' && Array.isArray(orgUnitInfo.unitSupervisors)
    ) {
      setUnitSupervisors(orgUnitInfo.unitSupervisors)
    }
  }, [orgUnitInfo])

  // useMemo(() => {
  //   if (
  //     newGroupForm && newGroupForm.supervisors && Array.isArray(newGroupForm.supervisors) &&
  //     supervisorList && Array.isArray(supervisorList)
  //   ) {
  //     const { supervisors: groupSupervisors } = newGroupForm

  //     const newGroupSupervisors = group
  //   }
  // }, [newGroupForm, supervisorList])

  const handleNodeAugment = async (key, children, isExpanded) => {
    if (isExpanded) {
      const tempSelected = [...expandedKeys]
      const keysToRemove = [key, ...keyify2(children)]

      const newSelected = tempSelected.filter((selectedKey) => keysToRemove.findIndex((removeKey) => removeKey === selectedKey) === -1)

      setExpandedKeys(newSelected)
    } else {
      const tempSelected = [...expandedKeys]
      const keysToAdd = [key, ...keyify2(children)]
      const addedKeys = []

      keysToAdd.forEach((addKey) => {
        if (tempSelected.findIndex((selectedKey) => selectedKey === addKey) === -1) {
          addedKeys.push(addKey)
        }
      })

      setExpandedKeys([...expandedKeys, ...addedKeys])
    }
  }

  // Adds the selected unit to the group object and ensures they can only select one
  const handleUnitSelect = (unit) => {
    setNewGroupForm({
      ...newGroupForm,
      unitID: unit
    })
  }

  // Makes sure if they are going backwards in the stepper it re-populates the value of the inputs
  useEffect(() => {
    if (newGroupForm.groupName !== '') {
      setNameInput(newGroupForm.groupName)
    }
    if (newGroupForm.groupDesc !== '') {
      setDescInput(newGroupForm.groupDesc)
    }
  }, [newGroupForm])

  // Put a character count on the inputs and puts them into a temporary local state
  const handleInputChange = (value) => e => {
    if (value === 'name') {
      if (groupNameInput.length < 50) {
        setNameInput(e.target.value)
      } else {
        setNameInput(groupNameInput.substr(0, 49))
      }
    } else if (value === 'desc') {
      if (groupDescInput.length < 255) {
        setDescInput(e.target.value)
      } else {
        setDescInput(groupDescInput.substr(0, 254))
      }
    }
  }

  // Translates the supervisorID into a readable name
  // const getDisplayName = (sup) => {
  //   console.log(sup)
  //   const index = supervisorList.findIndex(x => x.supervisorID === sup.supervisorID)
  //   if (index !== -1) {
  //     const firstName = supervisorList[index].firstName
  //     const lastName = supervisorList[index].lastName
  //     return `${firstName} ${lastName}`
  //   }
  // }

  // Translates the supervisorID into a readable name
  // const getDisplayNameFromIndex = (idx) => {
  //   if (idx !== -1) {
  //     return `${supervisorList[idx].firstName} ${supervisorList[idx].lastName}`
  //   }
  // }

  // Adds or splices the supervisorID in the array for the group's members
  const handleSupervisorSelect = (supervisorInfo) => {
    const tempList = [...newGroupForm.supervisors]

    if (tempList.findIndex(tempInfo => tempInfo.supervisorID === supervisorInfo.supervisorID) !== -1) {
      const newSupervisors = tempList.filter((tempInfo) => tempInfo.supervisorID !== supervisorInfo.supervisorID)

      setNewGroupForm({ ...newGroupForm, supervisors: newSupervisors })
    } else {
      const { supervisorID: unitSupervisorID, firstName, lastName } = supervisorInfo
      tempList.push({ supervisorID: unitSupervisorID, firstName, lastName })

      setNewGroupForm({ ...newGroupForm, supervisors: tempList })
    }
  }

  // The content of each Stepper's step
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      // Name and Description
      case 0:
        return (
          <Grid container item direction='row' className='w-100 mx-auto mb-4'>
            <Grid item container direction='column' spacing={2} className='m-auto w-100'>

              <Grid item container direction='row' justify='center'>
                <Grid container item xs={9} direction='column'>
                  <Typography variant='h6' className='text-primary font-weight-bold'> Group Name:</Typography>
                  <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted'> {`${groupNameInput.length} of 50`}</Typography>
                  <TextField
                    label='Required'
                    error={noNameError}
                    style={{ textTransform: 'none' }}
                    required variant='outlined'
                    value={groupNameInput}
                    helperText={noNameError ? 'Please Enter A Name' : ''}
                    onChange={handleInputChange('name')}
                  />
                </Grid>
              </Grid>

              <Grid item container direction='row' justify='center'>
                <Grid container item xs={9} direction='column'>
                  <Typography gutterBottom variant='h6' className='text-primary font-weight-bold'> Group Description:</Typography>
                  <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted'> {`${groupDescInput.length} of 255`}</Typography>
                  <TextField
                    multiline
                    error={noDescError}
                    helperText={noDescError ? 'Please Enter a Description' : ''}
                    rows={5}
                    label='Required'
                    style={{ textTransform: 'none' }}
                    required variant='outlined'
                    value={groupDescInput}
                    onChange={handleInputChange('desc')}
                  />
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        )
      case 1:
        // Select A Unit
        return (
          <Grid container item direction='row' justigy='center' className='w-100 mx-auto mb-4'>
            <Grid container item direction='column' alignItems='center' spacing={2} className='m-auto w-100'>

              <Grid item container direction='row' justify='center'>
                <Grid item xs={7}>
                  <Typography gutterBottom variant='h6' className='text-primary font-weight-bold'> Please Select A Unit for This Group:</Typography>
                  {noUnit &&
                    <Typography gutterBottom variant='overline' color='error' className='font-weight-bold'>You Must Select A Unit to Proceed</Typography>}
                  <Divider />
                </Grid>
              </Grid>

              <Grid item container direction='row' justify='center'>
                <Grid item xs={7}>
                  <TreeView expanded={expandedKeys} className={classes.unitTree} disableSelection>
                    <UnitTree
                      treeData={TreeData}
                      onNodeSelect={handleUnitSelect}
                      selectedKeys={[newGroupForm.unitID]}
                      expandedKeys={expandedKeys}
                      onNodeAugment={handleNodeAugment}
                    />
                  </TreeView>
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        )
      case 2:
        // Select Members
        return (
          <Grid container item direction='row' justify='center' className='w-100 mx-auto mb-4'>
            <Grid container item direction='column' alignItems='center' spacing={2} className='m-auto w-100'>

              <Grid item container direction='row' justify='center'>
                <Grid item xs={7}>
                  <Typography gutterBottom variant='h6' className='text-primary font-weight-bold'> Please Select the Members for This Group:</Typography>
                  {noSups &&
                    <Typography gutterBottom variant='overline' color='error' className='font-weight-bold'> You must Select at least one Member.</Typography>}
                  <Divider />
                </Grid>
              </Grid>

              <Grid item container direction='row' justify='center'>
                <Grid item container xs={7} direction='column' justify='center'>
                  {
                    unitSupervisors.map((supervisorInfo) => {
                      const { supervisorID: unitSupervisorID, firstName: unitFirstName = '', lastName: unitLastName = '' } = supervisorInfo

                      return (
                        <Grid item container direction='row' key={`supervisor-${unitSupervisorID}`} justify='space-between' alignItems='center' wrap='nowrap'>
                          <Grid item>
                            <Typography variant='body1' style={{ textTransform: 'none', fontWeight: 'bold' }}>{`${unitFirstName} ${unitLastName}`}</Typography>
                          </Grid>

                          <Grid item>
                            <GreenCheckbox
                              checked={newGroupForm.supervisors.findIndex(x => x.supervisorID === unitSupervisorID) !== -1}
                              size='small'
                              onChange={(event) => { event.stopPropagation(); handleSupervisorSelect(supervisorInfo) }}
                            />
                          </Grid>
                        </Grid>
                      )
                    })
                  }
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        )
      case 3:
        // Review and save
        return (
          <Grid container item direction='row' className='w-100 mx-auto mb-4'>
            <Grid container item direction='column' spacing={2} className='m-auto w-100'>

              <Grid container item direction='row' justify='center'>
                <Grid container item direction='column' xs={9}>
                  <Typography variant='h6' className='text-primary font-weight-bold'>Name:</Typography>
                  <Typography variant='body1' style={{ textTransform: 'none' }}>{newGroupForm.groupName}</Typography>
                </Grid>
              </Grid>

              <Grid container item direction='row' justify='center'>
                <Grid container item xs={9} direction='column'>
                  <Typography variant='h6' className='text-primary font-weight-bold'>Description:</Typography>
                  <Typography variant='body1' style={{ textTransform: 'none' }}>{newGroupForm.groupDesc}</Typography>
                </Grid>
              </Grid>

              <Grid container item direction='row' justify='center'>
                <Grid container item xs={9} direction='column'>
                  <Typography variant='h6' className='text-primary font-weight-bold'>Unit:</Typography>
                  <Typography variant='body1' style={{ textTransform: 'none' }}>{orgUnitInfo.unitName.replace('_', ' ')}</Typography>
                </Grid>
              </Grid>

              <Grid container item direction='row' justify='center'>
                <Grid container item xs={9} direction='column' className='mb-2'>
                  <Typography variant='h6' className='text-primary font-weight-bold'> Members:</Typography>
                  {
                    newGroupForm.supervisors.reduce((arr, supInfo) => {
                      if (typeof supInfo === 'object' && Boolean(supInfo) && Boolean(supInfo.supervisorID)) {
                        const { supervisorID: unitSupervisorID, firstName: unitFirstName = '', lastName: unitLastName = '' } = supInfo

                        arr.push(
                          <Typography key={`sup-${unitSupervisorID}`} variant='body1' style={{ textTransform: 'none' }}>
                            {`${unitFirstName} ${unitLastName}`}
                          </Typography>
                        )
                      }
                      return arr
                    }, [])
                  }
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        )
      default:
        return null
    }
  }

  const handleNext = (step) => {
    // If you are on Name and Description
    if (step === 0) {
      // Error handlers to require input
      if (groupNameInput.length === 0 && groupDescInput.length === 0) {
        setNoName(true)
        setNoDesc(true)
      } else if (groupDescInput.length === 0 && groupNameInput.length !== 0) {
        setNoDesc(true)
        setNoName(false)
      } else if (groupNameInput.length === 0 && groupDescInput.length !== 0) {
        setNoName(true)
        setNoDesc(false)
      } else {
        setNoName(false)
        setNoDesc(false)
        setNewGroupForm({
          ...newGroupForm,
          groupName: groupNameInput,
          groupDesc: groupDescInput
        })
        dispatch(setGroupIndex(step + 1))
      }
    }
    // If you are on Select A Unit
    if (step === 1) {
      if (newGroupForm.unitID === '') {
        setNoUnit(true)
      } else {
        setNoUnit(false)
        dispatch(setGroupIndex(step + 1))
        dispatch(getOrgUnitInfo(newGroupForm.unitID))
      }
    }
    // If you are on Select Members
    if (step === 2) {
      if (newGroupForm.supervisors.length === 0) {
        setNoSups(true)
      } else {
        setNoSups(false)
        dispatch(setGroupIndex(step + 1))
      }
    }
  }

  const handleBack = (step) => {
    // If you move backward at all in the stepper it will rease you memeber selection
    dispatch(setGroupIndex(step - 1))
    setNewGroupForm({
      ...newGroupForm,
      supervisors: []
    })
  }

  // Not sure this ever actually fires within the UI or even needs too
  const handleReset = () => {
    dispatch(setGroupIndex(0))
    setNewGroupForm({
      groupName: '',
      groupDesc: '',
      supervisors: [],
      unitID: ''
    })
  }

  return (
    <Grid container direction='row' className='w-100 mx-auto mt-4 mb-4'>
      <Paper className='w-100 mx-auto'>
        <Grid container item spacing={2} className='w-100 mx-auto' direction='row'>
          <Grid container item alignItems='center' xs={8} style={{ margin: '15px', padding: '5px' }}>
            <Typography
              gutterBottom
              variant='h4'
              style={{ textTransform: 'none', fontWeight: 'bold' }}
              className='text-primary mt-1'
            >
              Create New Group
            </Typography>
          </Grid>
          <Grid container item xs={2} direction='row' justify='flex-end' className='my-auto'>
            <Button size='medium' variant='contained' className={classes.greenBtn} onClick={handleBackTrack}>Cancel</Button>
          </Grid>
        </Grid>
        <Grid container item spacing={2} className='w-100 mx-auto mt-4' direction='column'>
          <Stepper activeStep={GroupIndex} alternativeLabel connector={<StepperConnector />}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={stepperIcons}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {/* call function for stepper content here */}
          <Grid container item direction='row' className='w-100 mx-auto my-auto'>
            {getStepContent(GroupIndex)}
          </Grid>
          {/* this will be for button options only */}
          <Grid container item spacing={2} className='w-100 mx-auto my-auto' direction='row'>
            {
              GroupIndex === steps.length
                ? (
                  <Grid container item spacing={1}>
                    <Typography className={classes.instructions}>All steps completed</Typography>
                    <Button onClick={handleReset}>Reset</Button>
                  </Grid>)
                : (
                  <Grid container item spacing={1} direction='column' className='w-100 mx-auto' style={{ marginBottom: '20px' }}>
                    <Grid container item justify='space-evenly'>
                      <Button
                        disabled={GroupIndex === 0}
                        onClick={() => handleBack(GroupIndex)}
                        className={classes.backButton}
                      >
                        Back
                      </Button>
                      {GroupIndex === steps.length - 1
                        ? <Button variant='contained' className={classes.saveButton} onClick={handleSaveNewGroup}>Save</Button>
                        : <Button variant='contained' className={classes.greenBtn} onClick={() => handleNext(GroupIndex)}>Next</Button>}
                    </Grid>
                  </Grid>)
            }
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default SupGroupNew
